// ============================================================
// CONTEST RESOLUTION — Step D of each Tick (SRS §3.3.5)
// ============================================================
//
// After combat, any contested tile (two enemy units sharing a tile
// from Step B) is resolved: the unit with lower HP retreats to its
// prior position; equal HP follows BattleDirector's historical
// tiebreaker (A retreats).

import type { BattleUnit } from '../BattleUnit.ts';
import type { ContestedRecord, RetreatRecord } from './types.ts';

export interface ContestResolutionResult {
  retreats: RetreatRecord[];
  stays: { unitId: string; pos: { x: number; y: number } }[];
}

export function resolveContest(
  units: BattleUnit[],
  contested: ContestedRecord[],
): ContestResolutionResult {
  const retreats: RetreatRecord[] = [];
  const stays: ContestResolutionResult['stays'] = [];

  for (const c of contested) {
    const a = units.find((u) => u.id === c.unitAId);
    const b = units.find((u) => u.id === c.unitBId);
    if (!a || !b) continue;

    if (a.dead && b.dead) continue;
    if (a.dead) { stays.push({ unitId: b.id, pos: { ...c.pos } }); continue; }
    if (b.dead) { stays.push({ unitId: a.id, pos: { ...c.pos } }); continue; }

    // Both alive — lower HP retreats. Equal HP → A retreats (legacy).
    if (a.hp <= b.hp) {
      retreats.push({ unitId: a.id, from: { ...c.pos }, to: { ...c.unitAFrom } });
      stays.push({ unitId: b.id, pos: { ...c.pos } });
      a.pos = { ...c.unitAFrom };
    } else {
      retreats.push({ unitId: b.id, from: { ...c.pos }, to: { ...c.unitBFrom } });
      stays.push({ unitId: a.id, pos: { ...c.pos } });
      b.pos = { ...c.unitBFrom };
    }
  }

  return { retreats, stays };
}
